import { create } from 'zustand';

import { User } from '@features/auth/services/authService';
import { Customers } from '@types/store.types';

export type HopDriveStore = {
  user?: User;
  rooftop?: Customers;
  customerConfig?: any;
  // Whether the initial customer-config resolution has settled for the current rooftop (success,
  // empty, or error). Config-gated surfaces register off `customerConfig`, which loads async after
  // the app mounts — this flag lets them wait instead of rendering an empty/absent state.
  customerConfigLoaded: boolean;
  organizationConfig?: any;
};

export const useStore = create<HopDriveStore>(() => ({
  user: undefined,
  rooftop: undefined,
  customerConfig: undefined,
  customerConfigLoaded: false,
  organizationConfig: undefined,
}));

export const getNonReactiveState = (): HopDriveStore => useStore.getState();

export const useUser = () => useStore(state => state.user);
export const setUser = (user?: User) => useStore.setState({ user });

export const useRooftop = () => useStore(state => state.rooftop);
export const setRooftop = (rooftop?: Customers) => useStore.setState({ rooftop });

export const useCustomerConfig = () => useStore(state => state.customerConfig);
export const setCustomerConfig = (customerConfig?: any) => useStore.setState({ customerConfig });

export const useCustomerConfigLoaded = () => useStore(state => state.customerConfigLoaded);
export const setCustomerConfigLoaded = (customerConfigLoaded: boolean) =>
  useStore.setState({ customerConfigLoaded });

export const useOrganizationConfig = () => useStore(state => state.organizationConfig);
export const setOrganizationConfig = (organizationConfig?: any) => useStore.setState({ organizationConfig });
